import { Link } from 'react-router-dom';
import { routes } from "../../../../constants";
import { useStoreActions } from "../../../../contexts";
import { Send1stAgreementIcon } from "../BusinessOnboardingWidget.icons";
import { ActionButton, StepLayout } from "../BusinessOnboardingWidget.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export default function SetupServices() {
  const {
    logBI
  } = useStoreActions();
  return /*#__PURE__*/_jsx(StepLayout, {
    id: "setupServices",
    title: "Set up services",
    subtitle: "List the services you offer, your pricing, and billing preferences",
    actions: /*#__PURE__*/_jsx(ActionButton, {
      "data-testid": "onboarding-widget-setup-services",
      as: Link,
      to: routes.serviceLibrary,
      onClick: () => logBI(11214),
      children: "Go to Services"
    }),
    icon: /*#__PURE__*/_jsx(Send1stAgreementIcon, {})
  });
}